'use client';

import { captureException } from '@sentry/nextjs';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

import { AuthMutation } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

interface GiftRecentViewRecorderProps {
  productNumber: string;
}

//* 상세는 무인증 캐시 경로라 서버가 회원을 모른다 — 최근 본 답례품 시트의 유일한 기록 경로다
export const GiftRecentViewRecorder = ({
  productNumber,
}: GiftRecentViewRecorderProps) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const recordedProductNumberRef = useRef<string | null>(null);
  const { mutate: recordRecentView } = useMutation(
    AuthMutation[
      'post:/wello/v1/auth/gift-products/{productNumber}/recent-view'
    ](),
  );

  useEffect(() => {
    if (
      isLogin !== true ||
      recordedProductNumberRef.current === productNumber
    ) {
      return;
    }

    recordedProductNumberRef.current = productNumber;
    recordRecentView(
      { path: { productNumber } },
      { onError: (error) => captureException(error) },
    );
  }, [isLogin, productNumber, recordRecentView]);

  return null;
};
